export default "__VITE_ASSET__fd6f3cb9__"